function addGA() {
    if (window.ga) {
        return;
    }

    /* eslint-disable */
    (function(i, s, o, g, r, a, m) {
        i.GoogleAnalyticsObject = r;
        i[r] = i[r] || function() {
            (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        document.body.appendChild(a);
    }(
        window,
        document,
        'script',
        'https://www.google-analytics.com/analytics.js',
        'ga',
    ));
    /* eslint-enable */

    window.ga('create', 'UA-23346503-19', 'auto');
    window.ga('require', 'ec');
    window.ga('send', 'pageview');
}

function dispatchGAEvent(action, event, payload) {
    if (event) {
        window.ga(action, event, payload);
    } else {
        window.ga(action, payload);
    }
}

export {
    addGA,
    dispatchGAEvent,
};
export default {
    addGA,
    dispatchGAEvent,
};
